import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconChevronTopOutlined = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M15.369 10.224a1 1 0 0 1 1.338.069l8.333 8.333a1 1 0 0 1-1.414 1.414L16 12.414 8.374 20.04a1 1 0 1 1-1.414-1.414l8.333-8.333z" /></svg>;
export default SvgIconChevronTopOutlined;